const bannerPrefix = 'Page_index_banner_imgs_'
const bannerDesPrefix = 'Page_index_banner_description_content_'
const sloganPrefix = 'Page_index_slogan_'
const productPrefix = 'Page_index_products_'
const footerContentPrefix = 'Page_index_footer_content_'

export function formatRes(res) {
  const keys = Object.keys(res)
  res.banners = getBanner(keys, res)
  res.bannerDescription = getBannerDescription(res)
  res.slogan = getByContructor(res, sloganPrefix)
  res.products = getByContructor(res, productPrefix)
  res.footerContent = getFooterContent(res)
  return res
}

function getBanner(keys, res) {
  return keys.filter(item => item.startsWith(bannerPrefix)).map(item => {
    return res[item]
  })
}

function getBannerDescription(res) {
  let index =1, arr = []
  while(res[bannerDesPrefix + index]) {
    arr.push(res[bannerDesPrefix + index])
    index ++
  }
  return arr
}

function getFooterContent(res) {
  const arr = []
  const keys =  Object.keys(res).filter(item => item.startsWith(footerContentPrefix))
  const push = type => arr.push({
    left: res[footerContentPrefix + type + '_left'],
    right: res[footerContentPrefix + type + '_right'],
  })
  const include = type => keys.includes(footerContentPrefix + type + '_left')
  const types = ['business', 'service', 'record', 'copyRight']
  types.forEach(item => {
    if (include(item)) {
      if (item === 'record') {
        arr.push({
          left: `<a href="https://beian.miit.gov.cn/">${res[footerContentPrefix + item + '_left']}</a>`,
          right: res[footerContentPrefix + item + '_right'],
        })
        return 
      }
      push(item)
    }
  })
  return arr
}


/**
 * @description 通过title
 */
function getByContructor(res, prefix) {
  let index =1, arr = []
  while(res[prefix + index + '_title']) {
    const obj = {}
    obj.title = res[prefix + index + '_title']
    obj.descriptionList = getContructorDescriptionList(res,index, prefix)
    arr.push(obj)
    index ++
  }
  return arr
}

function getContructorDescriptionList(res, index, prefix) {
  const descList =[]
  let i = 1
  while(res[prefix + index + '_description_' +i ]) {
    descList.push(res[prefix + index + '_description_' +i ])
    i ++
  }
  return descList
}
